import clsx from 'clsx';
import styles from './section-header.module.css';

interface SectionHeaderProps {
  title: string;
  editButton?: React.ReactNode;
  className?: string;
}

export function SectionHeader({ title, editButton, className }: SectionHeaderProps) {
  return (
    <div className={clsx(styles.sectionHeader, className)}>
      <p className={clsx('overline', styles.sectionHeaderTitle)}>{title}</p>
      {editButton}
    </div>
  );
}
